export default __webpack_public_path__ + "711def107d68fe4ebebd2d26bb21ed1d.png";